import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-coral-500 to-coral-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 px-4 leading-tight">
            まずはお気軽にご相談ください
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white mb-10 max-w-2xl mx-auto px-4 leading-relaxed">
            岡山市北区での訪問介護サービスについて、専門スタッフが丁寧にご説明いたします
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4">
            <a
              href="tel:086-012-3456"
              className="w-full sm:w-auto flex items-center justify-center space-x-2 bg-white text-coral-600 px-8 py-4 rounded-full hover:bg-beige-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer font-medium"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>086-012-3456</span>
            </a>
            <Link
              to="/services"
              className="w-full sm:w-auto flex items-center justify-center space-x-2 bg-navy-800 text-white px-8 py-4 rounded-full hover:bg-navy-900 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer font-medium"
            >
              <span>サービス詳細を見る</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>

          <div className="mt-10 text-white text-sm px-4">
            <p className="mb-2">営業時間：9:00 〜 18:00</p>
            <p>定休日：日曜日・祝日</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
